/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useRouter } from 'next/router';
import { GalleryItemOverlayProps } from '../types';
import trackEvent from '../../../utils/event-helper';
import { isMobile } from '../../../utils/browser-utils';
import { goToTemplateEditor } from '../../../utils/navigation-utils';
import { useStateValue } from '../../../state/stateProvider';
import classes from './galleryItemOverlay.module.scss';

const GalleryItemOverlay: React.FC<GalleryItemOverlayProps> = ({
  template, templateIndex, sectionName, needs,
}) => {
  const {
    overlay, previewBtn, templateBtn, mobileDesign,
  } = classes;
  const isDesktop = !isMobile();
  const [{ user, isIframe }] = useStateValue();
  const router = useRouter();
  const { data: { interactionId } } = template;

  const trackTemplateEvent = (eventName) => {
    trackEvent(eventName, {
      tabName: sectionName,
      channelVertical: router.query.vertical,
      templateOrder: templateIndex,
      templateName: template.name,
      templateId: template._id,
    });
  };

  const handleTemplate = () => {
    trackTemplateEvent('template_selected');
    goToTemplateEditor(interactionId, user, true, isIframe);
  };

  const getCtaButtonText = () => 'use template';

  const handlePreview = () => {
    trackTemplateEvent('template_preview_clicked');

    router.push({
      pathname: '/preview/[vertical]/[template]',
      query: {
        ...router.query,
        ...(needs && { tags: needs.join(',') }),
        template: interactionId,
      },
    });
  };

  return (
        <div className={`${overlay} ${!isDesktop ? mobileDesign : ''}`} data-testid="GalleryItemOverlay">
          { isDesktop && user?.userId && (
                 <button
                 className={`apeButton ${templateBtn}`}
                 onClick={handleTemplate}
                 >
                     {getCtaButtonText()}
                 </button>
          )
              }
               <button
               className={`apeButton ${previewBtn}`}
               onClick={handlePreview}
               >
                preview
               </button>
           </div>
  );
};

export default GalleryItemOverlay;
